import React from "react";
import { useInView } from "react-intersection-observer";
import { ShinyText } from "./Home";
import DownloadButton from "../../component/DownloadButton/DownloadButton";

const VoiceTypeOrTranslateSection = () => {
  const { ref: videoRef, inView: videoView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: buttonRef, inView: buttonView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <div className="flex md:flex-row flex-col-reverse items-center md:gap-2 gap-10 xl:pt-10 lg:pt-8 md:pt-6 xl:pb-10 lg:pb-8 z-[5] md:pb-6 lg:px-10 md:px-6 px-0 ">
      <div className=" flex-1 flex justify-center items-center">
        {/* <div
          ref={videoRef}
          className={`lg:w-[85%] md:w-[90%] w-full xl:rounded-3xl rounded-2xl overflow-hidden transition-opacity duration-500 ${
            videoView ? `animate-slideUp` : "opacity-0"
          } `}
        >
          <Lottie animationData={T_T} loop style={{ width: "100%" }} />
        </div> */}
        <div
          ref={videoRef}
          className={`${
            videoView ? `animate-slideUp z-[3] anim-preserve` : "opacity-0 z-0"
          }  lg:w-[85%] md:w-[90%] w-full xl:rounded-3xl rounded-2xl overflow-hidden  `}
        >
          <video
            className={`w-full scale-105 `}
            src="https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/Meter%20(1).mp4"
            autoPlay
            loop
            muted
            playsInline
            webkit-playsinline="true"
            preload="metadata"
          />
        </div>
      </div>
      <div className=" flex-1 flex flex-col md:items-start items-center xl:gap-5 lg:gap-4  gap-3">
        <div
          ref={headingRef}
          className={`xl:text-[2.5rem]  lg:text-[2.2rem] md:text-[1.9rem] text-[2.1rem] md:text-left text-center  font-jakarta font-bold ${
            headingView
              ? `animate-slideUp z-[3] anim-preserve`
              : "opacity-0 z-0"
          }`}
        >
          <ShinyText
            text="5× Faster Efficiency"
            speed={5}
            className="custom-class text-wrap"
          />
          <br />
          Get More Done in Less Time
        </div>
        <div className=" xl:text-[1.438rem] z-[4] relative bg-white lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] md:text-left text-center leading-snug text-[#00000099] font-inter">
          Dictate instead of typing and finish emails, notes, messages, and
          documents up to 5× faster. Stay focused while ZeroTyping turns your
          voice into polished text instantly.
        </div>
        <div className="md:mt-3 mt-2">
          <DownloadButton ref={buttonRef} view={buttonView} />
        </div>
      </div>
    </div>
  );
};

export default VoiceTypeOrTranslateSection;
